import e from "styled-components";
import n, { useRef as r, useState as t, useEffect as o } from "react";
import a from "react-dom";
var c = e.div.withConfig({
  displayName: "baseStyles__BaseModalBackground"
})(["display:flex;position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:30;background-color:rgba(0,0,0,0.5);align-items:center;justify-content:center;"]);
function l(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var r = 0, t = new Array(n); r < n; r++) t[r] = e[r];
  return t;
}
function i(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var t,
        o,
        a = [],
        c = !0,
        l = !1;
      try {
        for (r = r.call(e); !(c = (t = r.next()).done) && (a.push(t.value), !n || a.length !== n); c = !0);
      } catch (e) {
        l = !0, o = e;
      } finally {
        try {
          c || null == r.return || r.return();
        } finally {
          if (l) throw o;
        }
      }
      return a;
    }
  }(e, n) || function (e, n) {
    if (e) {
      if ("string" == typeof e) return l(e, n);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? l(e, n) : void 0;
    }
  }(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function u() {}
function f() {}
f.resetWarningCache = u;
var p,
  s,
  d = function d() {
    function e(e, n, r, t, o, a) {
      if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== a) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }
    function n() {
      return e;
    }
    e.isRequired = e;
    var r = {
      array: e,
      bigint: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: n,
      element: e,
      elementType: e,
      instanceOf: n,
      node: e,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: f,
      resetWarningCache: u
    };
    return r.PropTypes = r, r;
  },
  y = (p = function p(e) {
    e.exports = d();
  }, p(s = {
    exports: {}
  }, s.exports), s.exports),
  m = y,
  b = n.createContext({}),
  v = b.Provider,
  g = b.Consumer;
function h(e) {
  var a = e.backgroundComponent,
    l = e.children,
    u = r(null),
    f = i(t(null), 2),
    p = f[0],
    s = f[1],
    d = i(t(c), 2),
    y = d[0],
    m = d[1];
  return o(function () {
    a && m(a);
  }, [m, a]), o(function () {
    s(u.current);
  }, [s, u]), n.createElement(v, {
    value: {
      modalNode: p,
      BackgroundComponent: y
    }
  }, l, n.createElement("div", {
    ref: u
  }));
}
function O() {
  return O = Object.assign ? Object.assign.bind() : function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var t in r) Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
    }
    return e;
  }, O.apply(this, arguments);
}
function w(e, n) {
  if (null == e) return {};
  var r,
    t,
    o = function (e, n) {
      if (null == e) return {};
      var r,
        t,
        o = {},
        a = Object.keys(e);
      for (t = 0; t < a.length; t++) r = a[t], n.indexOf(r) >= 0 || (o[r] = e[r]);
      return o;
    }(e, n);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (t = 0; t < a.length; t++) r = a[t], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
h.propTypes = {
  backgroundComponent: m.oneOfType([m.element, m.object])
};
var C = ["WrapperComponent", "children", "onBackgroundClick", "onEscapeKeydown", "allowScroll", "beforeOpen", "afterOpen", "beforeClose", "afterClose", "backgroundProps", "isOpen"];
function k(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), t = 1; t < n; t++) r[t - 1] = arguments[t];
  e && e.apply(void 0, r);
}
function E(e) {
  var c,
    l = e.WrapperComponent,
    u = e.children,
    f = e.onBackgroundClick,
    p = e.onEscapeKeydown,
    s = e.allowScroll,
    d = e.beforeOpen,
    y = e.afterOpen,
    m = e.beforeClose,
    b = e.afterClose,
    v = e.backgroundProps,
    h = void 0 === v ? {} : v,
    E = e.isOpen,
    j = w(e, C),
    S = r(null),
    T = r(null),
    _ = r(!1),
    P = i(t(!1), 2),
    x = P[0],
    A = P[1];
  function B(e) {
    S.current === e.target && f && f(e);
  }
  return o(function () {
    function e(e) {
      A(e), k(e ? y : b);
    }
    function n(n) {
      if (n) {
        var r = n();
        "function" == typeof (null == r ? void 0 : r.then) ? (_.current = !0, r.then(function () {
          e(E), _.current = !1;
        })) : e(E);
      } else e(E);
    }
    x === E || _.current || n(E ? d : m);
  }, [_, x, E, d, m, b, y]), o(function () {
    function e(e) {
      "Escape" === e.key && p && p(e);
    }
    return x && document.addEventListener("keydown", e), function () {
      document.removeEventListener("keydown", e);
    };
  }, [x, p]), o(function () {
    return x && !s && (T.current = document.body.style.overflow, document.body.style.overflow = "hidden"), function () {
      s || (document.body.style.overflow = T.current || "");
    };
  }, [x, s]), c = l ? n.createElement(l, j, u) : u, n.createElement(g, null, function (e) {
    var r = e.modalNode,
      t = e.BackgroundComponent;
    return r && t && x ? a.createPortal(n.createElement(t, O({}, h, {
      onClick: B,
      ref: S
    }), c), r) : null;
  });
}
E.styled = function () {
  for (var r = arguments.length, t = new Array(r), o = 0; o < r; o++) t[o] = arguments[o];
  var a = t ? e.div.withConfig({
    displayName: "Modal__wrap"
  }).apply(void 0, t) : e.div.withConfig({
    displayName: "Modal__wrap"
  })();
  return function (e) {
    return n.createElement(E, O({
      WrapperComponent: a
    }, e));
  };
}, E.propTypes = {
  WrapperComponent: m.oneOfType([m.element, m.object]),
  onBackgroundClick: m.func,
  onEscapeKeydown: m.func,
  allowScroll: m.bool,
  beforeOpen: m.func,
  afterOpen: m.func,
  beforeClose: m.func,
  afterClose: m.func,
  backgroundProps: m.object,
  isOpen: m.bool
};
export { c as BaseModalBackground, h as ModalProvider, E as default };